const GB = 1024 * 1024 * 1024;
const MB = 1024 * 1024;
/** Max upload size for presigned inspection video POST. */
export const MAX_INSPECTION_VIDEO_FILE_SIZE = 1 * GB;
/** Max upload size for presigned inspection image POST. */
export const MAX_INSPECTION_IMAGE_FILE_SIZE = 20 * MB;
/** Max upload size for presigned inspection document POST. */
export const MAX_INSPECTION_DOCUMENT_FILE_SIZE = 25 * MB;
/** Max upload size for presigned inspection floorplan visualization POST. */
export const MAX_INSPECTION_FLOORPLAN_VISUALIZATION_FILE_SIZE = 1 * GB;
export const RAW_FLOORPLAN_VISUALIZATION_CONTENT_TYPE = 'model/vnd.usdz+zip';
